module.exports = __webpack_public_path__ + "img/renewalicon.3bc29f3f.svg";